import PageConsumption from './PageConsumption';
import { connect } from 'react-redux';
import { getUsage, getGeneralUse } from '../../actions/usage';
import { AppState } from '../../interfaces';
import { setMeta } from '../../actions';
import { listLocations } from '../../actions/location';
const mapStateToProps = (state: AppState) => ({
  usage: state.usageReducer,
  listLocation: state.listLocationReducer,
});

const mapDispatchToProps = (dispatch) => ({
  getUsage: (id) => dispatch(getUsage(id)),
  getGeneralUse: () => dispatch(getGeneralUse()),
  setMeta: (propertyId) => dispatch(setMeta(propertyId)),
  listLocations: () => dispatch(listLocations()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PageConsumption);
